import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { FindSectionsApi, FindSectionsRequest, FindSectionsResponse } from '../find-sections-api';
import { GuestAwareHttpService } from '../../services/guest-aware-http-service';

@injectable()
export class FindSectionsApiImpl extends GuestAwareHttpService implements FindSectionsApi {
    async findSections(request: FindSectionsRequest): Promise<FindSectionsResponse> {
        const res = await this.postWithGuestSupport<FindSectionsResponse>(
            {
                data: request,
                timeout: 600000,
            },
            'find_sections'
        );
        return res;
    }
}
